import { useEffect, useRef, useState } from "react";
import { Autocomplete, TextField, InputAdornment, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import search from "../../assets/images/search.png";
import DatePicker from "react-multi-date-picker";
import calender from "../../assets/images/calender.png";
import moment from 'moment';
import RefreshIcon from '@mui/icons-material/Refresh';
import StageWiseCostBarChart from "./charts/stageWiseBarChart";
import VendorWisePieChart from "./charts/vendorWisePieChart";
import VendorWiseCostingTable from "./charts/vendorWiseCostingTable";
import ApplicationFunnel from "./charts/applicationfunnel";
import axiosInstance from "../../helpers/axios";
import ApiAnalyticsTopCards from "./AnalyticsTiles";
import { useSelector } from "react-redux";
import axios from "axios";

export default function ApiAnalytics() {
  const user = null
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [vendorData, setVendorData] = useState([]);
  const [vendorLoading, setVendorLoading] = useState(true);
  const [vendorError, setVendorError] = useState(null);

  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [tableError, setTableError] = useState(null);

  const [instituteList, setInstituteList] = useState([])
  const [startingPhrase, setStarterPhrase] = useState("Type Institute Name")
  const [id, setId] = useState(null);
  const [internalValue, setInternalValue] = useState("");
  const [startDate, setStartDateFrom] = useState();
  const [endDate, setEndDateTo] = useState();
  const [searchId, setSearchId] = useState(null)
 const [funnelData, setFunnelData] = useState([]);
  const [funnelLoading, setFunnelLoading] = useState(false);
  const [funnelError, setFunnelError] = useState(null);
  const [tilesData, setTilesData] = useState(null);
// const [productType,setProductType]=useState('all')
  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
  const STAGE_WISE_URL = "/api-analytics/stage-wise";
  const VENDOR_WISE_URL = "/api-analytics/vendor-wise";
  const TABLE_DATA_URL = "/api-analytics/vendor-wise/tableData";
  const FUNNEL_DATA_URL = "/analytics/status-wise";


  const fetchAllData = (instituteId, customStartDate = null, customEndDate = null) => {

    let queryParams = {};
    if (instituteId) {
      queryParams.instituteId = instituteId;
    }
    if (customStartDate && customEndDate) {
      queryParams.startDate = moment(customStartDate, 'DD MMM YYYY').format('YYYY-MM-DD');
      queryParams.endDate = moment(customEndDate, 'DD MMM YYYY').format('YYYY-MM-DD');
    } else {
      const startDateFrom = moment().startOf('month');
      const endDateTo = moment();
      queryParams.startDate = startDateFrom.format('YYYY-MM-DD');
      queryParams.endDate = endDateTo.format('YYYY-MM-DD');
    }
    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
    setLoading(true);
    axiosInstance
      .get(STAGE_WISE_URL, {
        params: queryParams,
      })
       
      .then((res) => {
        setData(res?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("stage-wise fetch failed:", err);
        setError("Failed to load costing data.");
        setLoading(false);
      });

    setVendorLoading(true);
    axiosInstance
      .get(VENDOR_WISE_URL, {
        params: queryParams,
      })

      .then((res) => {
        setVendorData(res?.data?.data || []);
        setVendorLoading(false);
      })
      .catch((err) => {
        console.error("vendor-wise fetch failed:", err);
        setVendorError("Failed to load vendor data.");
        setVendorLoading(false);
      });

    setTableLoading(true);
      axiosInstance
      .get(TABLE_DATA_URL, {
        params: queryParams,
      })
      .then((res) => {
        setTableData(res?.data?.data || []);
        setTableLoading(false);
      })
      .catch((err) => {
        console.error("table data fetch failed:", err);
        setTableError("Failed to load table data.");
        setTableLoading(false);
      });

    setFunnelLoading(true);
    axiosInstance
      .get(FUNNEL_DATA_URL, {
        params: queryParams,
      })
      .then((res) => {
        const apiData = res?.data?.data;
        const transformedData = [
          { stage: "Total Applications", applications: apiData.total_applications || 0, color: "#9798e8" },
          { stage: "Approved", applications: apiData.approved_count || 0, color: "#5de3b7" },
          { stage: "Disbursed", applications: apiData.disbursed_count || 0, color: "#80e891" },
          { stage: "On Hold", applications: apiData.on_hold_count || 0, color: "#ffb1c1" },
          { stage: "Rejected", applications: apiData.rejected_count || 0, color: "#f36d6d" },
          { stage: "Dropped", applications: apiData.dropped_count || 0, color: "#efbd73" },
        ].sort((a, b) => Number(b.applications) - Number(a.applications));
        setFunnelData(transformedData);
        setTilesData(apiData);
        setFunnelLoading(false);
        setFunnelError(null);
      })
      .catch((err) => {
        console.error("funnel data fetch failed:", err);
        setFunnelError("Failed to load funnel data.");
        setFunnelLoading(false);
      });

  };


  useEffect(() => {
    fetchAllData(null);
  }, [productTypeSelected]);


  useEffect(() => {
    if (searchId === null) return;
    fetchAllData(searchId, startDate, endDate);
  }, [searchId]);


  const getInstituteInfo = async (text) => {
    const trimmedText = text.trim();


    if (!trimmedText || trimmedText.length < 4) {
      setInstituteList([]);
      setStarterPhrase("Type Institute Name");
      return;
    }


    const instituteInfoUrl = `/institute/info/name?name=${trimmedText}`;
    try {
      const response = await axiosInstance.get(instituteInfoUrl, {
        headers: {
        },
      });

      const institutes = response?.data?.data || [];
      if (institutes.length === 0) {
        setInstituteList([]);
        setStarterPhrase("No institute found");
      } else {
        const formattedData = institutes.map((item) => ({
          label: item.brandName,
          id: item.id,
          ...item,
        }));
        setInstituteList(formattedData);
        setStarterPhrase("");
      }
    } catch (error) {
      console.error("Error fetching institute info:", error);
    }
  }
  const handleButtonClick = () => {
    if (!internalValue.trim()) {
      setId(null);
      setInternalValue("");
      setSearchId(null);
      fetchAllData(null, startDate, endDate);
    } else {
      if (searchId === id) {
        fetchAllData(id);
      } else {
        setSearchId(id);
      }
    }
  };

  return <>
    <div style={{ width: "100%", backgroundColor: '#f9fafa', minHeight: '100vh' }}>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            marginTop: '20px',
            width: '100%',
            flexWrap: 'nowrap',
          }}
        >
          <Autocomplete
            sx={{ ml: 3 }}
            freeSolo={false}
            noOptionsText={startingPhrase}
            disablePortal
            size="small"
            value={internalValue}
            options={instituteList.map((item) => item.brandName)}
            onInputChange={(event, newInputValue, reason) => {
              if (reason === 'clear') {
                setId(null);
                setInternalValue("");
                setInstituteList([]);
                setStarterPhrase("Type Institute Name");
                fetchAllData(null);
                return;
              }
              if (reason === "input") {
                getInstituteInfo(newInputValue);
                const matchedItem = instituteList.find(
                  (item) => item.brandName.toLowerCase().trim() === newInputValue.toLowerCase().trim()
                );
                if (matchedItem) {
                  setId(matchedItem.id);
                  setInternalValue(matchedItem.brandName);
                } else {
                  setId(null);
                  setInternalValue("");
                }
              }
            }}
            onChange={(event, selectedValue) => {
              if (!selectedValue) {
                setId(null);
                setInternalValue("");
                return;
              }
              const selectedItem = instituteList.find((item) => item.brandName === selectedValue);
              if (selectedItem) {
                setId(selectedItem.id);
                setInternalValue(selectedItem.brandName);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Institute Name"
                placeholder="Atleast 4 Characters"
                InputLabelProps={{
                  sx: {
                    fontFamily: "Outfit",
                    bgcolor: "#fff8f4",
                    fontWeight: "bold",
                    borderRadius: "5px",
                    fontSize: "16px",
                    padding: "2px 8px",
                    color: "#000",
                    marginLeft: '20px'
                  },
                }}
                sx={{
                  minWidth: 300,
                  "& .MuiOutlinedInput-root": {
                    paddingLeft: '40px',
                    paddingRight: '60px',
                    height: '40px',

                    "& fieldset": { borderColor: "#707C8B" },
                    "&:hover fieldset": { borderColor: "#707C8B" },
                    "&.Mui-focused fieldset": { borderColor: "#707C8B" },
                    "& input": { marginRight: '50px', fontFamily: 'Outfit' },
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={search} alt="Search" style={{ width: "20px", height: "20px" }} />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />

          <div style={{ height: '40px', width: '230px' }}>

            <DatePicker
              value={startDate && endDate ? [startDate, endDate] : null}
              style={{
                height: '40px',
                borderRadius: '5px',
                paddingLeft: '38px',
                paddingRight: '12px',
                fontSize: '14px',
                fontFamily: 'Outfit',
                border: '1px solid #707C8B',
                backgroundColor: '#f9fafa',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '10px center',
                backgroundSize: '16px 16px',
                backgroundImage: `url(${calender})`,
                boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                cursor: 'pointer',
              }}
              placeholder="Select date range"
              allowClear={true}
              format="DD MMM YYYY"
              onChange={(dates, dateStrings) => {
                setStartDateFrom(dateStrings?.validatedValue[0]);
                setEndDateTo(dateStrings?.validatedValue[1]);
              }}
              range
            />
          </div>
 
    

          <button
            style={{
              backgroundColor: '#D22129',
              display: 'flex',
              alignItems: 'center',
              width: '130px',
              height: '40px',
              justifyContent: 'center',
              borderRadius: '5px',
              cursor: 'pointer',
              color: 'white',

              border: 'none',
              marginTop: '0px',
              fontFamily: 'Inter-Medium',
            }}
            onClick={handleButtonClick}
          >
            Search Results
          </button>


          <button
            onClick={() => {
              setId(null);
              setInternalValue("");
              setSearchId(null);
              setStartDateFrom(null);
              setEndDateTo(null);
              setInstituteList([]);
              
              fetchAllData(null, null, null);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              height: '40px',
              padding: '0 16px',
              backgroundColor: '#D22129',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              fontFamily: 'Inter-Medium',
              fontSize: '14px',
              cursor: 'pointer',
              whiteSpace: 'nowrap',

              marginTop: '0px',
            }}
          >
            <RefreshIcon />
          </button>
        </div>
        <div style={{ marginTop: '20px', padding: '0 10px' }}>
          <ApiAnalyticsTopCards data={tilesData} loading={funnelLoading} />
        </div>

        <div
          style={{
            display: "flex",
            gap: "20px",
            marginTop: "20px",
            flexDirection: "column",
          }}
        >
          {/* First Row: Stage-wise and Vendor-wise */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            {/* stagewise */}
            <div
              style={{
                flex: "1 1 calc(50% - 10px)",
                minWidth: "500px",
                height: "500px",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                padding: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {loading && (
                <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
                  Loading chart…
                </div>
              )}
              {!loading && error && (
                <div style={{ textAlign: "center", padding: "40px", color: "#d32f2f" }}>
                  {error}
                </div>
              )}
              {!loading && !error && <StageWiseCostBarChart apiData={data} />}
            </div>

            {/* vendorwise */}
            <div
              style={{
                flex: "1 1 calc(50% - 10px)",
                minWidth: "500px",
                height: "500px",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                padding: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {vendorLoading && (
                <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
                  Loading vendor chart…
                </div>
              )}
              {!vendorLoading && vendorError && (
                <div style={{ textAlign: "center", padding: "40px", color: "#d32f2f" }}>
                  {vendorError}
                </div>
              )}
              {!vendorLoading && !vendorError && (
                <VendorWisePieChart apiData={vendorData} />
              )}
            </div>
          </div>

          {/* Second Row: Table and Funnel */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            {/* tableData */}
            <div
              style={{
                flex: "1 1 calc(50% - 10px)",
                minWidth: "500px",
                height: "500px",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <VendorWiseCostingTable
                data={tableData}
                loading={tableLoading}
                error={tableError}
              />
            </div>

            {/* Funnel section */}
            <div
              style={{
                flex: "1 1 calc(50% - 10px)",
                minWidth: "500px",
                height: "500px",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                padding: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {funnelLoading ? (
                <div style={{ padding: "40px", textAlign: "center" }}>
                  Loading funnel...
                </div>
              ) : funnelError ? (
                <div style={{ padding: "40px", color: "red", textAlign: "center" }}>
                  {funnelError}
                </div>
              ) : (
                <ApplicationFunnel funnelData={funnelData} />
              )}
            </div>
          </div>
        </div>

    </div>

  </>
}